module.exports = __webpack_public_path__ + "img/p06.294393d4.jpg";